import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from '../Services/userservice.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute, Params } from "@angular/router";
import * as bcrypt from 'bcryptjs'

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

    constructor(
        private fb: UntypedFormBuilder,
        private _snackBar: MatSnackBar,
        private router: Router,
        private userService: UserService,
        private route: ActivatedRoute,
    ) {
        this.login = this.fb.group({
            password: ['', Validators.required],
            comfirmPassword: ['', Validators.required],
        }),
            this.status = '';
    }

    login: UntypedFormGroup;
    public status: string;
    public token;
    public realPass;
    public confirmPassword;
    public showSubmit = false;
    public validateRealPass = false;
    public validateConfirmPass = false;
    public samepass = false;

    verifyToken(token: any): void {
        const objectForSend = {
            token
        }
        this.userService.verifyToken(objectForSend).subscribe(
            res => {
                //console.log(res);
                if (res.name == "JsonWebTokenError") {
                    this.router.navigate(['login']);
                }

                if (res.status === 'error') {
                    this.router.navigate(['login']);
                }
            },
            err => {
                this.router.navigate(['login']);
            }
        )
    }

    pass(event): void {
        this.realPass = event.target.value;
        this.login.value.password = event.target.value;

        if (this.realPass === this.confirmPassword) {
            this.samepass = true;
            //this.showSubmit = true;
        } else {
            //this.showSubmit = false;
            this.samepass = false;
        }

        /* Validacion para verificar la contrasenia */

        var regex = /^(?=.{8,})(?=.*[a-z])(?=.*?[0-9])(?=.*[A-Z])(?=.*[@#$%^*&+=]).*$/g.test(this.realPass);
        console.log(regex , this.realPass);
        if (regex == false) {
            this.validateRealPass = true;
            //this.showSubmit = true;
        } else {
            this.validateRealPass = false;
            //this.showSubmit = true;
        }
        /* Validacion para verificar la contrasenia */
    }

    confirmPass(event): void {
        this.confirmPassword = event.target.value
        this.login.value.comfirmPassword = event.target.value

        if (this.realPass === this.confirmPassword) {
            //this.showSubmit = true;
        } else {
            this.showSubmit = false;
        }

        /* Validacion para verificar la contrasenia */
        var regex = /^(?=.{8,})(?=.*[a-z])(?=.*?[0-9])(?=.*[A-Z])(?=.*[@#$%^*&+=]).*$/g.test(this.confirmPassword);
        //console.log(regex);
        if (regex == false) {
            this.validateConfirmPass = true;
        } else {
            this.validateConfirmPass = false;
            this.showSubmit = true;
        }
        /* Validacion para verificar la contrasenia */
    }

    onSubmit(): void {
        try {
            const pass = this.login.value.password;
            const confirmPassowrd = this.login.value.comfirmPassword;

            if (pass == confirmPassowrd) {

                /* Convertimos contrasenia cruda en cifrada */
                const salt = bcrypt.genSaltSync(10);
                const password = bcrypt.hashSync(pass, salt);

                const objectForSend = {
                    token: this.token,
                    password
                }

                this.userService.changePass(objectForSend).subscribe(
                    res => {
                        //console.log(res);
                        if (res.status !== 'error') {
                            this._snackBar.open("Contraseña actualizada correctamente", "Cerrar");
                            this.router.navigate(['login']);
                        }
                    },
                    err => {
                        console.log(err);
                    }
                )
            }
        } catch (err) {
            return console.log(err);
        }
    }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            let token = params['token'];

            this.token = token;
            console.log(this.token)
        })

        this.verifyToken(this.token);
    }

}
 